import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { HelperArray } from 'src/app/_classi/HelperArray';
import { SpedizioniService } from 'src/app/_servizi/spedizioni.service';

@Component({
  selector: 'app-form-spedizione',
  templateUrl: './form-spedizione.component.html',
  styleUrls: ['./form-spedizione.component.css']
})
export class FormSpedizioneComponent implements OnInit, OnChanges {

  form: FormGroup;
  spDenominazioneFormControl = new FormControl('', [Validators.required]);
  spIndirizzoFormControl = new FormControl('', [Validators.required]);
  spHouseNumberFormControl = new FormControl('', [Validators.required]);
  spCapFormControl = new FormControl('', [Validators.required]);
  spCittaFormControl = new FormControl('', [Validators.required]);
  spProvinciaFormControl = new FormControl('', []);
  spTelefonoFormControl = new FormControl('', [Validators.required]);
  spCountryFormControl = new FormControl();
  spNoteFormControl = new FormControl();

  listaProvince = [];
  listaCitta = [];
  listaZip = [];
  hintCapRange = false;

  provinciaSelezionata = false;
  cittaSelezionata = false;
  prefix = null;

  filteredProvince: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  filteredCitta: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  filteredZip: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  optionsProvince = HelperArray.STATICONPROVINCE;
  statiProvinceSelect2Data = HelperArray.STATICONPROVINCESELECT2DATA;

  options = HelperArray.STATI;
  statiSelect2Data = HelperArray.STATISELECT2DATA;


  @Input() paeseSpedizione!: any;
  @Input() nome!: any;
  @Input() cognome!: any;
  @Input() telefono!: any;

  readonly = {
    citta_sp: true,
    cap_sp: true,
    indirizzo_sp: true,
    house_number_sp: true
  }

  @Output() formChanged = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private spedizioniService: SpedizioniService
  ) {
    this.form = this.fb.group({
      denominazione_sp: this.spDenominazioneFormControl,
      indirizzo_sp: this.spIndirizzoFormControl,
      house_number_sp: this.spHouseNumberFormControl,
      cap_sp: this.spCapFormControl,
      citta_sp: this.spCittaFormControl,
      provincia_sp: this.spProvinciaFormControl,
      telefono_sp: this.spTelefonoFormControl,
      country_sp: this.spCountryFormControl,
      note_sp: this.spNoteFormControl,
      country_text_sp: new FormControl(''),
      prefix: new FormControl('')
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.form.patchValue({
      denominazione_sp: this.nome && this.nome !== '' && this.cognome && this.cognome !== '' ? this.nome + ' ' + this.cognome : '',
      telefono_sp: this.telefono && this.telefono !== '' ? this.telefono : ''
    });

    if (this.paeseSpedizione) {
      if (this.paeseSpedizione === 'IT') {
        this.spProvinciaFormControl.setValidators([Validators.required]);
        this.spProvinciaFormControl.updateValueAndValidity();

        this.readonly.citta_sp = true;
        this.readonly.cap_sp = true;
        this.readonly.indirizzo_sp = true;
        this.readonly.house_number_sp = true;

        this.form.updateValueAndValidity();
      } else {
        this.spProvinciaFormControl.clearValidators();
        this.spProvinciaFormControl.updateValueAndValidity();

        this.readonly.citta_sp = false;
        this.readonly.cap_sp = false;
        this.readonly.indirizzo_sp = false;
        this.readonly.house_number_sp = false;

        this.form.updateValueAndValidity();
      }
    } else {
      this.spProvinciaFormControl.setValidators([Validators.required]);
      this.spProvinciaFormControl.updateValueAndValidity();
      this.form.updateValueAndValidity();
    }
  }

  ngOnInit(): void {

    this.form.patchValue({
      denominazione_sp: this.nome && this.nome !== '' && this.cognome && this.cognome !== '' ? this.nome + ' ' + this.cognome : '',
      telefono_sp: this.telefono && this.telefono !== '' ? this.telefono : ''
    });

    this.spedizioniService.getPublicProvince().subscribe(result => {
      this.listaProvince = result;
      this.filteredProvince.next(this.listaProvince);
    });

    if (this.paeseSpedizione && this.paeseSpedizione === 'IT') {
      this.readonly.citta_sp = true;
      this.readonly.cap_sp = true;
      this.readonly.indirizzo_sp = true;
      this.readonly.house_number_sp = true;
    }


    this.spProvinciaFormControl.valueChanges.subscribe(value => {
      if (!this.paeseSpedizione || (this.paeseSpedizione && this.paeseSpedizione === 'IT')) {
        if (value) {
          const filter = value.toLocaleLowerCase();
          const trovate = this.listaProvince.filter(provincia => provincia.provincia.toLowerCase().includes(filter) || provincia.sigla.toLowerCase().includes(filter));
          if (value == '') {
            this.filteredProvince.next(this.listaProvince);
          } else {
            this.filteredProvince.next(trovate);
          }
          if (trovate.length == 0) {
            this.spProvinciaFormControl.setErrors({ 'required': true });
            this.spCittaFormControl.setValue('');
            this.spCapFormControl.setValue('');
          }
        } else {
          this.filteredProvince.next(this.listaProvince);
          this.spProvinciaFormControl.setErrors({ 'required': true });
          this.spCittaFormControl.setValue('');
          this.spCapFormControl.setValue('');
          this.readonly.citta_sp = true;
          this.readonly.cap_sp = true;
        }
      }
    });
    this.spCittaFormControl.valueChanges.subscribe(value => {
      if (!this.paeseSpedizione || (this.paeseSpedizione && this.paeseSpedizione === 'IT')) {
        if (value) {
          const filter = value.toLocaleLowerCase();
          const trovate = this.listaCitta.filter(citta => citta.comune.toLowerCase().includes(filter));
          if (value == '') {
            this.filteredCitta.next(this.listaCitta);
          } else {
            this.filteredCitta.next(trovate);
          }
          if (trovate.length == 0) {
            this.spCittaFormControl.setErrors({ 'required': true });
            this.spCapFormControl.setValue('');
          }
        } else {
          this.filteredCitta.next(this.listaCitta);
          this.spCittaFormControl.setErrors({ 'required': true });
          this.spCapFormControl.setValue('');
          this.readonly.cap_sp = true;
        }
      }
    });
    this.spCapFormControl.valueChanges.subscribe(value => {
      if (!this.paeseSpedizione || (this.paeseSpedizione && this.paeseSpedizione === 'IT')) {
        if (value) {
          const filter = value.toLocaleLowerCase();
          const trovate = this.listaZip.filter(zip => zip.toLowerCase().includes(filter));
          this.filteredZip.next(trovate);
          if (trovate.length == 0) {
            this.spCapFormControl.setErrors({ 'required': true });
          }
        }
      }
    });

    this.form.valueChanges.subscribe(changes => {
      this.formChanged.emit(this.form);
    });
  }

  getPublicCitta(provincia) {
    this.spedizioniService.getPublicCitta(provincia).subscribe(result => {
      this.listaCitta = result;
      this.filteredCitta.next(this.listaCitta);
      this.spCittaFormControl.setValue('');
      this.spCittaFormControl.updateValueAndValidity();
    })
  }

  getPublicCap(citta) {
    let differenza: number;
    let nuovo = [];
    this.spedizioniService.getPublicZip(citta).subscribe(result => {
      this.listaZip = result;
      this.readonly.indirizzo_sp = false;
      this.readonly.house_number_sp = false;
      this.listaZip = this.listaZip[0].cap.split('-');
      if (this.listaZip.length > 1) {
        this.hintCapRange = true;
        differenza = parseInt(this.listaZip[1]) - parseInt(this.listaZip[0]) + 1;
        for (let index = 0; index < differenza; index++) {
          nuovo.push(
            this.padLeft(
              ((parseInt(this.listaZip[0]) + index).toString()),
              '0',
              5
            )
          )
        }
      } else {
        nuovo.push(
          this.padLeft(
            ((parseInt(this.listaZip[0])).toString()),
            '0',
            5
          )
        )
      }
      this.listaZip = nuovo;
      this.form.patchValue({ cap_sp: this.listaZip[0] });

    });
  }

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }

  changeProvincia(event) {
    if (event.option && event.option.value) {
      this.provinciaSelezionata = true;
      this.getPublicCitta(event.option.value);
      this.readonly.citta_sp = false;
      this.readonly.cap_sp = true;
      this.spCapFormControl.setValue('');
    } else {
      this.readonly.citta_sp = true;
      this.readonly.cap_sp = true;
      this.spCittaFormControl.setValue('');
      this.spCapFormControl.setValue('');
    }
  }

  changeCitta(event) {
    if (event.option && event.option.value) {
      this.cittaSelezionata = true;
      this.getPublicCap(event.option.value);
      this.readonly.cap_sp = false;
    } else {
      this.readonly.cap_sp = true;
      this.spCapFormControl.setValue('');
    }
  }

  onCountryChange(country): void {
    this.prefix = country.value.prefix;
    this.form.patchValue({
      prefix: this.prefix
    });
    const selected = country.value.id;
    const trovato = this.statiProvinceSelect2Data.filter(stato => stato.id === selected).length > 0 ? true : false;
    if (trovato) {
      this.spProvinciaFormControl.setValidators([Validators.required]);
      this.spProvinciaFormControl.updateValueAndValidity();
    } else {
      this.spProvinciaFormControl.clearValidators();
      this.spProvinciaFormControl.updateValueAndValidity();
    }
    this.form.patchValue({
      country_text_sp: country.value.text + ' - ' + selected
    });
    this.form.updateValueAndValidity();
  }

}
